import React from 'react'; // Standard to import React, though StrictMode is also from 'react'
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App'; // Changed from App.jsx, .tsx will be resolved
import { initPostHog } from './analytics';
import { initSentry } from './lib/sentry';

initPostHog();
initSentry();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error("Could not find root element with id 'root'");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
